<template lang="pug">
div(
    class="rich-text-container"
    :class="classes"
)
    Element(
        v-if="data.text"
        :data="data.text"
        :linkColor="linkColor"
    )
</template>

<script>
import {
    generateBackgroundColorClass,
    generateLineHeightClass,
    generateFontColorClass,
    generateTextAlignmentClasses,
} from '../../../helpers'
import Element from './element'

export default {
    name: 'TextWidget',
    components: {
        Element,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        linkColor() {
            if (!this.data.linkColor) return null
            return generateFontColorClass(this.data.linkColor)
        },
        classes() {
            const arr = [
                generateBackgroundColorClass(this.data.backgroundColor),
                generateFontColorClass(this.data.color),
                generateLineHeightClass(this.data.lineSpacing),
                generateTextAlignmentClasses(
                    this.data.mobileAlignment,
                    this.data.tabletAlignment,
                    this.data.desktopAlignment
                ),
            ]

            // Whitespace wrapping
            if (this.data.wordWrap === 'false') arr.push('whitespace-nowrap')

            return arr
        },
    },
}
</script>

<style lang="stylus">
.rich-text-container
    h1, h2, h3, h4, h5, h6
        @apply mt-0 mb-4
        color inherit

    h1
        @apply normal-case

    h2
        @apply text-2xl

    h3
        @apply text-xl

    h4
        @apply text-lg

    ol
        @apply list-decimal
        padding-left 1em

    ul
        list-style-type square
        padding-left 1.1em

    li p
        @apply mb-2

    p
        @apply mb-4

    > div > p:last-child
        @apply mb-0

@screen lg
    .rich-text-container
        h2
            @apply text-3xl

        h3
            @apply text-2xl

        h4
            @apply text-xl
</style>
